import { useContext } from 'react';
import useScript from '../../hooks/useScript';
import ConfigContext from '../../contexts/ConfigContext';

const Omniture = () => {
  const { OMNITURE_URL } = useContext(ConfigContext);

  useScript(
    OMNITURE_URL
  );

  return null;
};

export default Omniture;
